export function ScrollToDirective($document) {
    'ngInject';
    return {
        restrict: 'A',
        link: function(scope, elem) {
            var target = angular.element($document[0].querySelectorAll('[scroll-to-this]'));
            var targetParent = target.parent();
            scope.$watch(function() {
                return target[0].scrollHeight;
            }, scrollUp);

            function scrollUp() {
                var scroll = targetParent[0].scrollHeight - target[0].scrollHeight;
                elem[0].scrollTop = scroll;
            }
        }
    };
}
